// Author YuJiaBei
// Date 2021-01-05 08:33:12

class RepairEventLevel {
constructor({
        id = null,
        code = '',
        name = '',
        isAccident = ''}
= {}) {
    this.id = id;
    this.code = code;
    this.name = name;
    this.isAccident = isAccident;
}
}

function newEntity() {
return new RepairEventLevel();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'code',
        label: 'label.em.repair.repairEventLevel.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.em.repair.repairEventLevel.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'isAccident',
        label: 'label.em.repair.repairEventLevel.grid.isAccident',
        sortable: true,
        form: {
        type: 'boolean'
        }
        }
    ])}

const filter = {
    codeFilter : "",
    nameFilter : "",
    isAccidentFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'codeFilter',
        label: 'label.em.repair.repairEventLevel.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.em.repair.repairEventLevel.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'isAccidentFilter',
        label: 'label.em.repair.repairEventLevel.filter.isAccident',
        disabled: false,
        form: {
        type: 'boolean'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'code',
        label: 'label.em.repair.repairEventLevel.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'name',
        label: 'label.em.repair.repairEventLevel.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'isAccident',
        label: 'label.em.repair.repairEventLevel.entity.isAccident',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean'
                }
        }
]

export {RepairEventLevel, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
